/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { DirectoryWithKeyWithChildren } from './DirectoryWithKeyWithChildren';
import { InternalForUser } from './InternalForUser';
const UploadSubmissionByFileTreeAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['files', DirectoryWithKeyWithChildren],
    ['forUser', InternalForUser, 'for_user'],
    ['author', /* #__PURE__ */ codecOptional(codecNumber)],
]);
export class UploadSubmissionByFileTreeAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UploadSubmissionByFileTreeAssignmentDataParser.decode(input).map(res => new UploadSubmissionByFileTreeAssignmentData(res));
    }
    static unsafeDecode(input) {
        return UploadSubmissionByFileTreeAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UploadSubmissionByFileTreeAssignmentDataParser.encode(data);
    }
    static schema() {
        return UploadSubmissionByFileTreeAssignmentDataParser.schema();
    }
}
